module.exports = __webpack_public_path__ + "img/evaluate_gray_2.59dd52d7.png";